define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var Backbone = require('backbone');
    var ItemView = require('./view');
    var ItemViewNew = require('./viewNew');
    var SubMenuTpl = require('text!./subMenu.tpl').default;
    var MenuCollection = require('./collection');
    var StatisticSourcePositionCollection = require('./statisticSourcesPositionsCollection');
    var I18n = require('i18n!nls/main');
    var Handlebars = require('handlebars');
    var AppConfig = require("config/application");
    var Submenu = Handlebars.compile(SubMenuTpl);

    var Menu = Marionette.CollectionView.extend({
        tagName: 'ul',
        getChildView: function() {
            if (app.Models.Account.get('telephony_version') != 2) {
                return ItemView
            } else {
                return ItemViewNew;
            }
        },
        className: 'top-level',

        ui: {
            'sourcesList': '.js-sources-list',
        },

        events: {
            'click @ui.sourcesList': 'getSources',
        },

        activeMenuItem: false,
        firstRefresh: true,
        lastLink: null,

        initialize: function () {
            if (app.Models.Account.get('telephony_version') != 2) {
                MenuCollection.prototype.comparator = 'position';
            } else {
                MenuCollection.prototype.comparator = 'order';
            }
            this.collection = new MenuCollection();
            this.routeHandler = this.onRouteChange.bind(this);;
            this.checkClosestProxy = this.checkClosest.bind(this);

            if (app.Collections &&
                app.Collections[StatisticSourcePositionCollection.globalName] instanceof StatisticSourcePositionCollection) {
                this.statisticSourcesPositionsCollection = app.Collections[StatisticSourcePositionCollection.globalName];
            } else {
                this.statisticSourcesPositionsCollection = new StatisticSourcePositionCollection();
            }

            this.listenTo(this.collection, 'sync', this.render);
            this.listenTo(app, 'menu:refresh', this.refresh);
            this.listenTo(app.Vents, 'app:changeProject', this.onChangeProject);

            this.listenTo(app.Models.LeftMenuCount, 'change:leads_new change:deals_new', this.changeCounts);
            $(window).on('hashchange', this.routeHandler);
            $(document).on('click', this.checkClosestProxy);
        },

        changeCounts: function(countModel, count) {
            var crm = this.collection.get('crm');
            var leadsCount = countModel.get('leads_new');
            var dealsCount = countModel.get('deals_new');
            var submenu;
            if(crm) {
                submenu = crm.get('submenu');
                submenu[0].count = leadsCount;
                submenu[1].count = dealsCount;
                crm.set({
                    submenu: submenu
                });
            }
            this.render();
        },

        onRouteChange: function() {
            this.$('li').removeClass('active');
            this.checkCurrRoute();
        },

        onChangeProject: function() {
            this.refresh();
            this.checkCurrRoute();
        },

        onDestroy: function () {
            this.collection.off();
            $(window).off('hashchange', this.routeHandler);
            $(document).off('click', this.checkClosestProxy);
        },

        onShow: function () {
            var that = this;

            if (app.Collections &&
                app.Collections[MenuCollection.globalName] instanceof MenuCollection) {
                that.collection.set(app.Collections[MenuCollection.globalName].toJSON());
            }
            this.refresh();
            this.checkCurrRoute.call(this);
        },

        refresh: function () {
            this.collection = new MenuCollection();
            this.render();
            app.trigger('menu:refreshed');
            app.trigger('menu:refreshed_access');
        },


        checkClosest: function(event) {
            if (app.Models.Account.get('telephony_version') != 2 && (!$(event.target).closest(this.$('li.open')).length || !$(event.target).closest('.sub-menu'))) {
                $('#sidebar-content').find('li.open').removeClass('open');
                $('#main-menu-overlay').removeClass('active');
                this.trigger('close-menu');
            }
        },

        checkCurrRoute: function () {
            var hash = window.location.hash;
            var routeParams = hash.split('/');
            var links = this.$('a');
            var route;
            var currentLink;
            var currentLinks = [];

            var getHierarhy = function(links) {
                var newLinks = [];
                _.forEach(links, function(link) {
                    var parentLink;
                    if (link.parent_id) {
                        parentLink =  _.find(app.menu, {id: link.parent_id});
                        if (parentLink) {
                            newLinks.push(parentLink);
                            newLinks.concat(getHierarhy(newLinks));
                        }
                    }
                });

                return links.concat(newLinks);
            };

            this.checkAccess();
            if (app.Models.Account.get('telephony_version') != 2) {
                for (var i = routeParams.length; i > 0; i--) {
                    routeParams.splice(i, 1);
                    route = routeParams.join('/') || 'leads';
                    links.each(function (idx, link) {
                        if (!currentLink && link.href && link.href.indexOf(route) >= 0) {
                            currentLink = link;
                        }
                    });
                }

                if (currentLink) {
                    $(currentLink).parents('li').addClass('active');
                    this.setCurrentSelected(currentLink);
                }
            } else {
                if (!hash || hash == '#') {
                    hash = '#leads';
                }
                if (hash.indexOf('#contacts/card') >= 0) {
                    hash = '#contacts';
                }
                if (hash.indexOf('#leads/card') >= 0) {
                    hash = '#leads';
                }
                if (hash.indexOf('#deals/card') >= 0) {
                    hash = '#deals';
                }
                if (hash.indexOf('#calendar/task') >= 0) {
                    hash = '#calendar';
                }

                _.forEach(app.menu, function (item) {
                    if (item.url && item.url.match("^" + hash + "(\/|)$")) {
                        currentLinks.push(item);
                    }
                });

                currentLinks = getHierarhy(currentLinks);

                if (!currentLinks.length) {
                    var settings = _.find(app.menu, {name: 'Настройки'});

                    currentLinks.push(settings);
                }

                _.forEach(currentLinks, function(item) {
                    if(!item) return;
                    var link = this.$('a[data-id="'+item.id+'"]');
                    $(link).parents('li').addClass('active');
                    this.setCurrentSelected(link);
                }.bind(this))
            }
        },

        setCurrentSelected: function (item) {
            this.$('li>a').removeClass('lpt-current-open-menu lpt-current-open-menu-mini');
            this.$(item).addClass('lpt-current-open-menu lpt-current-open-menu-mini');
        },

        checkAccess: function () {
            this.collection.each(function (model) {
                var title = model.get('title'),
                    pageName = I18n.staff.accessPagesList[title];

                if (pageName) {
                    model.set('hide', app.checkAccess(pageName));
                }
            });
        },

        getSources: function(event) {
            if (!$(event.target).closest('li').hasClass('open')) {
                this.statisticSourcesPositionsCollection
                    .fetch()
                    .then(function () {
                        this.collection
                            .fetch()
                            .then(function () {
                                this.refresh();
                                this.checkCurrRoute.call(this);
                                this.$('li').removeClass('open');
                                this.$('a[data-id="statistic"]').parents('li').addClass('open');
                                this.$('a[data-id="sources"]').parents('li').addClass('open');
                            }.bind(this))
                    }.bind(this));
            }
        }
    });

    return Marionette.LayoutView.extend({
        template: '<div class="js-menu"></div>',

        ui: {
            'link'    : 'a',
            'subLinks': '.sub-menu a',
            'subMenu': '.sub-menu'
        },

        events: {
            'mouseenter .js-show-submenu': 'showSubmenuHover',
            'mouseenter .js-nosubmenu'   : 'noSubmenuHover',
            'mouseleave li'              : 'hideMiniSubMenu',
            'click .js-show-submenu'     : 'showSubmenu',
            'click @ui.subLinks'         : 'hideSublinks',
            'click .js-nosubmenu'        : 'noSubmenu',
            'mouseleave @ui.subMenu'     : 'onMouseleaveSubmenu',
            'click @ui.link'             : 'onClickLink',
        },

        regions: {
            regionMenu        : '.js-menu',
        },

        initialize: function() {
            this.removeAllSubmenuProxy = this.removeAllSubmenu.bind(this);
            this.routeHandler = this.onRouteChange.bind(this);

            $('#main-menu-overlay').on('mousemove', this.removeAllSubmenuProxy);
            $(window).on('hashchange', this.routeHandler);
        },

        onRender: function() {
            var menu = new Menu();

            this.listenTo(menu, 'close-menu', this.removeAllSubmenu);
            this.regionMenu.show(menu);
        },

        disableMenuScroll: function (event) {
            $(event.target).scrollLeft(0);
        },

        onMouseleaveSubmenu: function (event) {
            if (!$(event.relatedTarget).closest('ul.sub-menu').length) {
                this.removeAllSubmenu();
            }
        },

        onRouteChange: function() {
            if (app.Models.Account.get('telephony_version') == 2) {
                this.removeAllSubmenu();
            }
        },

        noSubmenuHover: function (e) {
            var that = this;
            var opened = $('body').hasClass('sidebar-opened');
            var item = e.currentTarget;
            var parent = $(item).parent().parent();
            var sub = $(item).next();
            var subVisible = sub.is(":visible");

            if (!opened) {
                parent.children('li').removeClass('open');
                $('#main-menu-overlay').removeClass('active');
                this.removeAllSubmenu();
            }
        },

        showSubmenuHover: function (e) {
            var that = this;
            var opened = $('body').hasClass('sidebar-opened');
            var item = e.currentTarget;

            if (!opened) {
                $('#sidebar-content').addClass('menu-hovered');
                $('#main-menu-wrapper').scroll(this.disableMenuScroll);
            }

            if (opened) {
                e.preventDefault();
                e.stopPropagation();
                return false;

            } else {

                if (app.Models.Account.get('telephony_version') != 2) {
                    var has_submenu = true;
                    var has_fix = true;
                    var elm_sub = false;
                    var elm_fix = false;
                    if ($(item).next().hasClass('sub-fix') === false) {
                        has_fix = false;
                    } else {
                        elm_fix = $(item).next();
                    }
                    if (has_fix) {
                        if ($(item).next().next().hasClass('sub-menu') === false) {
                            has_submenu = false;
                        } else {
                            elm_sub = $(item).next().next();
                        }
                    } else {
                        if ($(item).next().hasClass('sub-menu') === false) {
                            has_submenu = false;
                        } else {
                            elm_sub = $(item).next();
                        }
                    }

                    var parent = $(item).parent().parent();
                    var subVisible = elm_sub && elm_sub.is(":visible");

                    parent.children('li').removeClass('open');

                    if (elm_sub !== false) {
                        if (subVisible) {
                            //$(item).removeClass("open");
                            //$('#main-menu-overlay').removeClass('active');

                        } else {
                            if (($(item).siblings('ul').children('li').length * 30 + 18 + top) > $(window).height()) {

                            } else if ($('body').hasClass('visible-alert')) {

                            }

                            $(item).parent().addClass("open");
                            $('#main-menu-overlay').addClass('active');
                        }

                        if ($(item).next().data('menu_level') != undefined &&
                            $(item).next().data('menu_level') == 3) {
                            $(item).parent().find('ul').first().css('top', $(item).parent().position().top + 'px');
                        }
                    }
                } else {
                    var id = $(item).data('id');
                    var level = $(item).data('level');
                    var currentItem = _.findWhere(app.menu, {id: id});
                    var submenuItems = _.where(app.menu, {parent_id: id});
                    var top;
                    var left;
                    var bottom;

                    this.removeSubmenuMoreLevel(level);

                    if (level > 0) {
                        top = $(item).parent().position().top;
                        left = $(item).closest('ul.sub-menu').offset().left;
                        left += 230;
                        bottom = 'auto';
                    }

                    if (submenuItems.length) {
                        var submenu = $(Submenu({
                            items: submenuItems,
                            parent: id,
                            name: currentItem.name,
                            level: ++level,
                            left: left,
                            top: top,
                            bottom: bottom,
                        }));

                        submenu.css({
                            display: 'block'
                        });
                        submenu.mouseleave(function (event) {
                            var toElement = $(event.toElement || event.relatedTarget);
                            var prevListEl = $(event.target).prop('tagName') == 'UL' ? $(event.target) : $(event.target).closest('ul.sub-menu');
                            var listEl = toElement.prop('tagName') == 'UL' ? toElement : toElement.closest('ul.sub-menu');

                            if (($(event.target).data('id') != listEl.data('parentId')) && (prevListEl.data('level') != listEl.data('level') - 1)) {
                                that.removeSubmenu(id);
                            }
                        });
                        this.$el.append(submenu);
                        this.checkCurrRoute();
                        $('#main-menu-overlay').addClass('active');
                    }
                }

                e.preventDefault();
            }
        },

        showSubmenu: function (e) {
            var _this = this;
            var item = e.currentTarget;
            var $item = $(item);

            this.setCurrentSelected(item);

            if ($item.next().hasClass('sub-menu') === false) {
                return;
            }

            var parent = $item.parent().parent();
            var subVisible = $item.next().is(":visible");

            parent.children('li').removeClass('open');

            var sub = $item.next();
            if (subVisible) {
                $('#main-menu-overlay').removeClass('active');
                this.removeAllSubmenu();
            } else {
                $item.parent().addClass("open");
                $('#main-menu-overlay').addClass('active');
            }

            if ($item.attr('href') == '#') {
                e.preventDefault();
            }
        },

        noSubmenu: function (e) {
            //this.$('.sub-menu').slideUp(200);
            this.$('li').removeClass('open');
            $('#main-menu-overlay').removeClass('active');
            this.removeAllSubmenu();
            this.$('li>a').removeClass('lpt-current-open-menu lpt-current-open-menu-mini');
            this.setCurrentSelected(e.currentTarget);
            window.location.href = $(e.currentTarget).attr('href');
            $('body').removeClass('sidebar-opened');
        },

        setCurrentSelected: function (item) {
            this.$('li>a').removeClass('lpt-current-open-menu lpt-current-open-menu-mini');
            this.$(item).addClass('lpt-current-open-menu lpt-current-open-menu-mini');
        },

        hideMiniSubMenu: function (e) {
            if (app.Models.Account.get('telephony_version') != 2) {
                e.stopPropagation();
            }
            var that = this;
            var opened = $('body').hasClass('sidebar-opened');
            var item = e.currentTarget;

            if (!opened) {
                $('#sidebar-content').removeClass('menu-hovered');
            }

            if (opened) {
                e.preventDefault();
                e.stopPropagation();

                return false;
            } else {
                if (app.Models.Account.get('telephony_version') != 2) {
                    $(item).removeClass("open");
                //$(item).parent().removeClass('open');
                    if ($(item).children('ul').data('menu_level') != undefined &&
                        $(item).children('ul').data('menu_level') == 2) {
                        $('#main-menu-overlay').removeClass('active');
                    }
                } else {
                    var id = $($(item).children()[0]).data('id');
                    var target = $(e.toElement || e.relatedTarget);

                    if ($(item).closest('ul')[0] != target[0]) {
                        this.removeSubmenu(id, target)
                    }
                }
            }
        },

        removeSubmenu: function(id, target) {
            if (!target || !target.closest('ul[data-parent-id="'+id+'"]').length) {
                this.$('ul[data-parent-id="' + id + '"]').remove();
            }
            if (!this.$('ul[data-parent-id]').length) {
                $('#main-menu-overlay').removeClass('active');
                this.removeAllSubmenu();
            }
        },

        removeAllSubmenu: function() {
            if (app.Models.Account.get('telephony_version') == 2) {
                this.$('ul.sub-menu').remove();
                $('#main-menu-overlay').removeClass('active');
            }
        },

        removeSubmenuMoreLevel: function(level) {
            if (app.Models.Account.get('telephony_version') == 2) {
                this.$('ul.sub-menu').each(function(item) {
                    if ($(this).data('level') > level) {
                        $(this).remove();
                    }
                });
                if (!this.$('ul[data-parent-id]').length) {
                    $('#main-menu-overlay').removeClass('active');
                    this.removeAllSubmenu();
                }
            }
        },

        hideSublinks: function (e) {
            var parent = $(e.target).closest('.top-level');
            this.setCurrentSelected(parent.children('a')[0]);
            if (!$(e.target).hasClass('js-show-submenu')) {
                parent.find('.open').removeClass('open');
                $('body').removeClass('sidebar-opened');
            }
        },

        checkCurrRoute: function () {
            var hash = window.location.hash;
            var currentLinks = [];
            var getHierarhy = function(links) {
                var newLinks = [];
                _.forEach(links, function(link) {
                    var parentLink;
                    if (link.parent_id) {
                        parentLink =  _.find(app.menu, {id: link.parent_id});
                        if (parentLink) {
                            newLinks.push(parentLink);
                            newLinks.concat(getHierarhy(newLinks));
                        }
                    }
                });

                return links.concat(newLinks);
            };

            if (!hash || hash == '#') {
                hash = '#leads';
            }
            if (hash.indexOf('#contacts/card') >= 0) {
                hash = '#contacts';
            }
            if (hash.indexOf('#leads/card') >= 0) {
                hash = '#leads';
            }
            if (hash.indexOf('#deals/card') >= 0) {
                hash = '#deals';
            }
            if (hash.indexOf('#calendar/task') >= 0) {
                hash = '#calendar';
            }

            _.forEach(app.menu, function (item) {
                if (item.url && item.url.match("^" + hash + "(\/|)$")) {
                    currentLinks.push(item);
                }
            });

            currentLinks = getHierarhy(currentLinks);

            if (!currentLinks.length) {
                var settings = _.find(app.menu, {name: 'Настройки'});

                currentLinks.push(settings);
            }

            _.forEach(currentLinks, function(item) {
                var link = this.$('a[data-id="'+item.id+'"]');
                $(link).parents('li').addClass('active');
                this.setCurrentSelected(link);
            }.bind(this))
        },

        onClickLink: function(event) {
            // var target = $(event.currentTarget);

            // if (target.attr('href') && target.attr('href') != '#' && target.attr('href') == '#' + Backbone.history.fragment) {
            //     Backbone.history.loadUrl(target.attr('href'));
            // }
        },

        destroy: function() {
            $('#main-menu-overlay').off('mousemove', this.removeAllSubmenuProxy);
        }
    })
});
